module.exports = __webpack_public_path__ + "static/media/IMG_2538.1cb12ef9.JPG";